import ComponentRenderer from "../../../newStructure/core/ComponentRenderer";

const DefaultDivider = () => {

    return (
        <div className="header-flag-div">
            <div style={{background: "var(--secondary)"}}/>
            <div style={{background: "var(--tertiary)"}} />
            <div style={{background: "var(--primary)"}}/>
        </div>
    )

}

const Divider = () => {
    return <ComponentRenderer defaultComponent={DefaultDivider} componentName="header-divider" />;
}

export default Divider;
